// extracted by mini-css-extract-plugin
module.exports = {"links":"TravelLinks_links__CPzfy","text":"TravelLinks_text__t1_b1","link":"TravelLinks_link__F15Ct"};